import BarChartIcon from '@mui/icons-material/BarChart';
import StorageIcon from '@mui/icons-material/Storage';

const ALL = 'all';
const NEW = 'new'; // -> freemium
const PENDING = 'pending'; // => pending
const PAID = 'paid';
const RECURRING = 'recurring'; // -> in storage

export const BILLING_QUEUE_TYPE = 'billing_queue';
export const ARCHIVED_TYPE = 'archived';

export const BILLING_STATUS = {
  PENDING,
  PAID,
  RECURRING,
};

export const BILLING_TAB = {
  ALL,
  NEW,
  PENDING,
  RECURRING,
};

export const BILLING_TABS_LIST = [
  {
    value: BILLING_TAB.ALL,
    label: 'all',
  },
  {
    value: BILLING_TAB.NEW,
    label: 'new',
  },
  {
    value: BILLING_TAB.PENDING,
    label: 'pending',
  },
  {
    value: BILLING_TAB.RECURRING,
    label: 'recurring',
  },
];

export const BLOCK_MANAGER_TAB = 'block_manager';
export const DATA_MANAGEMENT_TAB = 'data_management';
export const BILLING_TABS = [
  {
    name: 'Block Manager',
    Icon: BarChartIcon,
    value: BLOCK_MANAGER_TAB,
  },
  {
    name: 'Data Management',
    Icon: StorageIcon,
    value: DATA_MANAGEMENT_TAB,
  },
];

export const NEW_TAB_TOOLTIP =
  'These blocks are in the 60-day freemium storage period. No action is necessary.';
export const PENDING_TAB_TOOLTIP =
  'Blocks will be moved from free to paid recurring storage within 7 days. To make a change, you can request a return shipment, disposal, or contribute these items to HistoWiz directly from your Blocks dashboard.';
export const RECURRING_TAB_TOOLTIP =
  'These blocks are secure within our Block Management Solution.';
